import {AppThunkAction} from '../../../types/redux'

import {
  aFetchIntermediaryShareholders,
  selectIntermediaryShareholdersWhereLoaded,
} from '../../../data/intermediary-shareholders'

export const selectIntermediaryShareholderItemsArePending = (state: Record<string, any>): boolean =>
  !selectIntermediaryShareholdersWhereLoaded(state)

export const aInitializeIntermediaryShareholdersItems =
  (): AppThunkAction<void> =>
  (dispatch): void => {
    dispatch(aFetchIntermediaryShareholders())
  }
